import { FormGroup } from '@angular/forms';
import { ModuleWithComponentFactories } from '@angular/core';
import { Moment } from 'moment';
import * as moment from 'moment/moment';
import { DatePipe } from '@angular/common';
import { UnitOfMeasurement } from 'src/app/models/internal/unit-of-measurement';
import { MatCheckbox } from '@angular/material';
import Helper from 'src/app/core/utility/helper';

export default class Calculator {
    static GetTotalWeight_Primary(QPC: number, partWeight: number, primaryTareWeight: number): number {
        return Helper.roundto3((partWeight * QPC) + primaryTareWeight);
    }
    static GetTotalWeight_Secondary(primaryTotalWeight: number, ContainersPerLayer: number, NoOfLayers: number, secondaryTareWeight: number): number {
        if (!primaryTotalWeight || !ContainersPerLayer || !NoOfLayers) {
            return null;
        } else {
            return Helper.roundto3((primaryTotalWeight * NoOfLayers * ContainersPerLayer) + secondaryTareWeight);
        }
   }
   static GetTotalWeight_Tertiary(secondaryTotalWeight: number, ContainersPerLayer: number, NoOfLayers: number, tertiaryTareWeight: number): number {
    if (!secondaryTotalWeight || !ContainersPerLayer || !NoOfLayers) {
        return null;
    } else {
        return Helper.roundto3((secondaryTotalWeight * NoOfLayers * ContainersPerLayer) + tertiaryTareWeight);
    }
    }

    static GetTotalPartQuantity_Primary(parimaryQPC: number): number {
            return parimaryQPC;
    }
    static GetTotalPartQuantity_Secondary(parimaryQPC: number, ContainersPerLayer: number, NoOfLayers: number): number {
        if (!ContainersPerLayer || !NoOfLayers) {
            return null;
        } else {
            return (parimaryQPC * NoOfLayers * ContainersPerLayer);
        }
    }
    static GetTotalPartQuantity_Tertiary(secondaryTotalPartQuantity: number, ContainersPerLayer: number, NoOfLayers: number): number {
        if (!secondaryTotalPartQuantity || !ContainersPerLayer || !NoOfLayers) {
            return null;
        } else {
            return (secondaryTotalPartQuantity * NoOfLayers * ContainersPerLayer);
        }
    }
    static GetTotalContainerQuantity_Primary(): number {
        return null;
    }
    static GetTotalContainerQuantity_Secondary(ContainersPerLayer: number, NoOfLayers: number): number {
        if (!ContainersPerLayer || !NoOfLayers) {
            return null;
        } else {
            return (ContainersPerLayer * NoOfLayers);
        }
    }
    static GetTotalContainerQuantity_Tertiary(SecondaryTotalContainerQuantity: number, ContainersPerLayer: number, NoOfLayers: number): number {
        if (!SecondaryTotalContainerQuantity || !ContainersPerLayer || !NoOfLayers) {
            return null;
        } else {
            return (SecondaryTotalContainerQuantity * ContainersPerLayer * NoOfLayers);
        }
    }

    static GetTotalPackageHeightSecondary(packageheightPrimary: number, secNoOfLayers: number, PackageHeightSec: number): number {
        if (!packageheightPrimary || !secNoOfLayers || !PackageHeightSec) {
            return null;
        } else {
            return Helper.roundto3(((packageheightPrimary * secNoOfLayers) + PackageHeightSec));
        }
    }

}